import React from 'react'
import PropTypes from 'prop-types'

import Box from '../styled/Box'

function Icon(props = {}) {
  return (
    <Box
      as="svg"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size}
      height={props.size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {props.children}
    </Box>
  )
}

Icon.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  size: PropTypes.string,
}

Icon.defaultProps = {
  size: '20',
}

export default Icon
